import storage from './store';

export const relativeTimestamps = storage('relativeTimestamps', true);
export const localDates = storage('localDates', true);
